export default __webpack_public_path__ + "static/N0235-e590205d34fe91c4bd3e6a9c5e8d78a0.png";